<template>
  <rank-division-picker
    :type="'currentRank'"
    item-key="winBoosting"
    :title="$t('calculators_common.current_rank')"
    class="full-width"
  />
  <RangePicker
    :title="$t('calculators_common.number_of_wins')"
    :description="$t('calculators_common.select_number_of_wins')"
    type="wins-over"
    :max="5"
  />
  <ExtraOptionPicker :options="['server', 'ranked_mode']" />
  <PlatformPicker />
  <OptionPicker :mandatory-option="mandatoryOption" />
  <RolesPicker :select-only-one-role="true" />
  <ChampionsPicker />
</template>

<script setup>
import RankDivisionPicker from "./pickers/RankDivisionPicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import RolesPicker from "../lol/pickers/RolesPicker.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import RangePicker from "../commonpickers/RangePicker.vue";
import PlatformPicker from "../commonpickers/PlatformPicker.vue";
import ChampionsPicker from "../commonpickers/ChampionsPicker.vue";
import { computed, onMounted } from "vue";

const checkoutStore = useCheckoutStore();
const { getGame, getGamePack } = useGameStore();
const gameStore = useGameStore();

const mandatoryOption = computed(() => {
  if (checkoutStore.getSelectedPlatform === 4) {
    return 105;
  }
  return null;
});
const rankedMode = computed(() => {
  if (gameStore.getGamePack?.pack_extra_options) {
    return gameStore.getGamePack?.pack_extra_options?.find(
      (op) => op.description === "ranked_mode"
    );
  }
  return null;
});
const handleDetails = () => {
  checkoutStore.clearCheckout();
  if (rankedMode.value) {
    checkoutStore.setPackExtraOptions({
      ranked_mode: rankedMode.value?.id,
    });
  }
  checkoutStore.setDetails({
    currentDivision: 144,
    currentDivisionTitle: "V",
    currentRank: 44,
    currentRankTitle: "Bronze",
    numberOfWins: 1,
  });

  checkoutStore.setServer("52");
  checkoutStore.setPlatform({
    platform: 1,
  });

  checkoutStore.setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();
onMounted(() => {
  checkoutStore.setCalculating();
});
</script>
